module.exports = __webpack_public_path__ + "static/figma-198ae786a30bec0927d4c856c9c1f83f.svg";